module.exports = __webpack_public_path__ + "assets/img/block-right-b9c988ab.png";